export const careerContact = {
    title: "Ready to find your next career?",
    subtitle: "Find your career today",
    btnText: "Contact Us",
}
